<template>
  <section
    id="platform"
    class="odin-platform odin-section container-wrapper"
    aria-labelledby="odin-platform-title"
  >
    <div class="platform-copy">
      <p class="odin-eyebrow">THE SOFTWARE. THE STARTING POINT.</p>
      <h2 id="odin-platform-title">
        A browser interface.<br />A setup built around you.
      </h2>
      <p>
        ODIN’s existing application brings source checks, content work and
        review into a browser interface. We agree where your implementation runs
        and how you access it before setup.
      </p>
      <p class="platform-availability">
        Enquiries open now for tailored implementation. No robot required.
      </p>
      <div class="platform-details">
        <p>
          <strong>Your project, in context.</strong> Discuss the sources,
          evidence and content requirements that should shape your
          implementation.
        </p>
        <p>
          <strong>Your workflow, your decisions.</strong> Use the agreed modules
          for drafting, review or planning. ARI-operated production and
          reporting are scoped separately in your proposal.
        </p>
      </div>
      <a class="text-link" href="#workflows"
        >Explore ODIN’s demo <span aria-hidden="true">↓</span></a
      >
    </div>
    <div class="platform-preview">
      <div
        class="platform-view-switch"
        role="group"
        aria-label="Choose an ODIN interface concept"
      >
        <button
          v-for="(view, index) in views"
          :key="view.id"
          type="button"
          :aria-pressed="selected === index"
          aria-controls="odin-interface-concept"
          @click="selected = index"
        >
          {{ view.label }}
        </button>
      </div>
      <figure id="odin-interface-concept">
        <a
          :href="active.full"
          target="_blank"
          rel="noopener"
          :aria-label="
            'Open full-size ' + active.label + ' interface concept in a new tab'
          "
        >
          <picture :key="active.id">
            <source
              :srcset="active.small + ' 768w, ' + active.full + ' 1536w'"
              sizes="(max-width: 900px) calc(100vw - 48px), 62vw"
              type="image/webp"
            />
            <img
              :src="active.full"
              :alt="active.alt"
              width="1536"
              height="1024"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </a>
        <figcaption>
          <span>GENERATED INTERFACE CONCEPT · SAMPLE DATA</span
          ><a :href="active.full" target="_blank" rel="noopener"
            >View full-size ↗</a
          >
        </figcaption>
      </figure>
      <p class="platform-preview-note">
        {{ active.caption }} Generated visualisations, not screenshots of the
        current software. The analytics dashboard and connector controls are
        proposed interfaces. Implemented drafting and knowledge review use
        different screens; these concepts do not establish customer access.
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: "OdinPlatform",
  data() {
    return {
      selected: 0,
      views: [
        {
          caption:
            "Planned analytics concept: identify pages behind a traffic change. Search Console is not an implemented connector.",
          id: "workspace",
          label: "Workspace",
          small: "/odin/platform/workspace-768.webp",
          full: "/odin/platform/workspace-1536.webp",
          alt: "ODIN Workspace interface concept for fictional Willow Studio: search clicks, website findings and a suggested update, using sample data.",
        },
        {
          caption:
            "Content review concept: follow a brief through drafting and review. The visual design and publishing controls are illustrative.",
          id: "review",
          label: "Workflow review",
          small: "/odin/platform/review-768.webp",
          full: "/odin/platform/review-1536.webp",
          alt: "ODIN Workspace workflow review concept with a fictional content brief, review stages and an action awaiting approval. Planned interface using sample data.",
        },
      ],
    };
  },
  computed: {
    active() {
      return this.views[this.selected];
    },
  },
};
</script>
